import { Component, OnInit } from '@angular/core';
import { UserService } from '../../shared/user.service';
import { ErrorHandler } from '../../shared/ErrorHandler';

@Component({
  selector: 'app-all-unassigned-tickets',
  templateUrl: './all-unassigned-tickets.component.html',
  styleUrls: ['./all-unassigned-tickets.component.css']
})
export class AllUnassignedTicketsComponent implements OnInit {
  u:any={};

  constructor(private userService: UserService,private errorHandler: ErrorHandler) { }

  ngOnInit() {
    // this.NewUnassignedTickets();
  }

  NewUnassignedTickets = function(){
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.newUnassignedTickets(this.u.FromDate,this.u.ToDate)
    .subscribe((data:any)=>{
      this.TicketsList = data;
      document.getElementById('loader-spinner').style.display = "none";
    },(error)=>{
      document.getElementById('loader-spinner').style.display = "none";
      this.errorHandler.HandlerError(error);
    });

}

Print = function () {
  window.print()
}

}



// WEBPACK FOOTER //
// ./src/app/reports/all-unassigned-tickets/all-unassigned-tickets.component.ts